import type { RootState } from "types/redux";

export const getEmergingThemesItems = (state: RootState) => state.domains.emergingThemes.items;

export const getEmergingThemesIsPending = (state: RootState) => state.domains.emergingThemes.isPending;

export const getEmergingThemesOffset = (state: RootState) => state.domains.emergingThemes.offset;

export const getEmergingThemesHasNextPage = (state: RootState) => state.domains.emergingThemes.hasNextPage;
